import { HttpClient } from '@angular/common/http';
import { mockGroup } from '@app/shared/mockdata/groups-list';
import { GroupInfo } from '@app/shared/models/group-info.model';
import { environment } from '@env/environment';
import { catchError, map, Observable, timeout } from 'rxjs';
import { ApiClientConfig } from '../api-client.config';

export class GroupApi {
  private apiUrl: string = environment.API_URL;

  constructor(
    public readonly http: HttpClient,
    public config: ApiClientConfig
  ) {}

  // mock data
  getAll() {
    return mockGroup;
  }

  getById(id: string) {
    const data = mockGroup.groups.find(item => {
      return item.id === id;
    });
    return data;
  }

  searchByName(name: string) {
    const data = mockGroup.groups.filter(item =>
      item.name.toLowerCase().includes(name.toLowerCase())
    );
    return data;
  }

  deleteGroup(id: string) {
    const index = mockGroup.groups.findIndex(group => group.id === id);
    if (index >= 0) {
      mockGroup.groups.splice(index, 1);
    } else {
      console.log('group does not exit.');
    }
  }

  addGroup(group: GroupInfo) {
    if (group.avatar.length === 0) {
      group.avatar = '../../../assets/images/avatar.png';
    }
    mockGroup.groups.push(group);
  }

  getGroupSummary(startDateEpochMillis: number, endDateEpochMillis: number): Observable<any> {
    return this.http
      .get<any>(
        `${this.apiUrl}/group/management/v2?startDateEpochMillis=${startDateEpochMillis}&endDateEpochMillis=${endDateEpochMillis}`
      )
      .pipe(
        timeout(this.config.responseTimeout),
        map(res => {
          return res;
        }),
        catchError(error => {
          throw error.error;
        })
      );
  }

  getGroupGrowth(
    viewType: string,
    startDateEpochMillis: number,
    endDateEpochMillis: number
  ): Observable<any> {
    return this.http
      .get<any>(
        `${this.apiUrl}/group/management/group-growth?viewType=${viewType}&startDateEpochMillis=${startDateEpochMillis}&endDateEpochMillis=${endDateEpochMillis}`
      )
      .pipe(
        timeout(this.config.responseTimeout),
        map(response => {
          return response;
        }),
        catchError(error => {
          throw error.error;
        })
      );
  }

  getGroupPostGrowth(
    viewType: string,
    startDateEpochMillis: number,
    endDateEpochMillis: number
  ): Observable<any> {
    return this.http
      .get<any>(
        `${this.apiUrl}/group/management/post-growth?viewType=${viewType}&startDateEpochMillis=${startDateEpochMillis}&endDateEpochMillis=${endDateEpochMillis}`
      )
      .pipe(
        timeout(this.config.responseTimeout),
        map(response => {
          return response;
        }),
        catchError(error => {
          throw error.error;
        })
      );
  }

  getMembershipGrowth(
    viewType: string,
    startDateEpochMillis: number,
    endDateEpochMillis: number
  ): Observable<any> {
    return this.http
      .get<any>(
        `${this.apiUrl}/group/management/membership-growth?viewType=${viewType}&startDateEpochMillis=${startDateEpochMillis}&endDateEpochMillis=${endDateEpochMillis}`
      )
      .pipe(
        timeout(this.config.responseTimeout),
        map(response => {
          return response;
        }),
        catchError(error => {
          throw error.error;
        })
      );
  }

  getMemberAgeCount(startDateEpochMillis: number, endDateEpochMillis: number): Observable<any> {
    return this.http
      .get<any>(
        `${this.apiUrl}/group/management/age-count?startDateEpochMillis=${startDateEpochMillis}&endDateEpochMillis=${endDateEpochMillis}`
      )
      .pipe(
        timeout(this.config.responseTimeout),
        map(response => {
          return response;
        }),
        catchError(error => {
          throw error.error;
        })
      );
  }

  getMemberGenderCount(startDateEpochMillis: number, endDateEpochMillis: number): Observable<any> {
    return this.http
      .get<any>(
        `${this.apiUrl}/group/management/gender-count?startDateEpochMillis=${startDateEpochMillis}&endDateEpochMillis=${endDateEpochMillis}`
      )
      .pipe(
        timeout(this.config.responseTimeout),
        map(response => {
          return response;
        }),
        catchError(error => {
          throw error.error;
        })
      );
  }

  getGroupPrivacyCount(startDateEpochMillis: number, endDateEpochMillis: number): Observable<any> {
    return this.http
      .get<any>(
        `${this.apiUrl}/group/management/privacy-growth?startDateEpochMillis=${startDateEpochMillis}&endDateEpochMillis=${endDateEpochMillis}`
      )
      .pipe(
        timeout(this.config.responseTimeout),
        map(response => {
          return response;
        }),
        catchError(error => {
          throw error.error;
        })
      );
  }

  getTopGroup(
    type: string,
    startDateEpochMillis: number,
    endDateEpochMillis: number,
    count: number
  ): Observable<any> {
    return this.http
      .get<any>(
        `${this.apiUrl}/group/management/top-group?type=${type}&startDateEpochMillis=${startDateEpochMillis}&endDateEpochMillis=${endDateEpochMillis}&count=${count}`
      )
      .pipe(
        timeout(this.config.responseTimeout),
        map(response => {
          return response;
        }),
        catchError(error => {
          throw error.error;
        })
      );
  }

  getTopGroupPost(
    type: string,
    startDateEpochMillis: number,
    endDateEpochMillis: number,
    count: number
  ): Observable<any> {
    return this.http
      .get<any>(
        `${this.apiUrl}/group/management/top-group-post?type=${type}&startDateEpochMillis=${startDateEpochMillis}&endDateEpochMillis=${endDateEpochMillis}&count=${count}`
      )
      .pipe(
        timeout(this.config.responseTimeout),
        map(response => {
          return response;
        }),
        catchError(error => {
          throw error.error;
        })
      );
  }
}
